import { Route } from 'react-router-dom';

import { PaymentGatewayDetailPage } from './pages/payment-gateway-detail-page.js';
import { PaymentGatewayFormPage } from './pages/payment-gateway-form-page.js';
import { PaymentGatewayListPage } from './pages/payment-gateway-list-page.js';

/**
 * Payment gateway routes, served under /payment-gateways.
 *
 * The static /new route is listed before the /:gatewayId parameter route so a
 * reader does not have to know React Router's ranking to see which matches.
 */
export function paymentGatewayRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/payment-gateways" element={<PaymentGatewayListPage />} />
      <Route path="/payment-gateways/new" element={<PaymentGatewayFormPage />} />
      <Route path="/payment-gateways/:gatewayId/edit" element={<PaymentGatewayFormPage />} />
      <Route path="/payment-gateways/:gatewayId" element={<PaymentGatewayDetailPage />} />
    </>
  );
}
